module.exports = __webpack_public_path__ + "img/1.3b9e40d6.jpg";